const EntityType = {
  ALERT: 1,
  SUBSCRIPTION: 2,
  DEVICE: 3,
  DATAGROUP: 4,
  USER: 5,
  ACCOUNT_MESSAGE: 6,
  ALERT_COMMENT: 7,
  THRESHOLD_RANGE: 8,
  THRESHOLD_RANGE_GROUP: 9,
  USER_ALERT_DATA: 10,
  USER_ASSIGNMENT: 11,
  PENDING_USER_ASSIGNMENT: 12,
};

export default EntityType;
